// Mui Imports
import {
  Typography,
  Grid,
  Button,
  Skeleton,
  Stack,
  Alert,
  Box,
} from "@mui/material";
import { Add } from "@mui/icons-material";

// React Imports
import { useEffect, useState } from "react";

// Project Imports
import "./Applications.css";
import ApplicationsGrid from "./Components/ApplicationsGrid";
import NewApplicationPanel from "./Components/NewApplicationPanel";
import { getApplications } from "src/apis/controllers/applications";
import { useLoading } from "src/hooks/useLoading";

const url = import.meta.env.VITE_REACT_APP_BASE_URL;

const Applications = () => {
  const [newApplication, setNewApplication] = useState(false);
  const [applications, setApplications] = useState(false);
  const [settings, setSettings] = useState({ canCreate: false, message: "" });
  const [applicationTypes, setApplicationTypes] = useState([]);
  const { loading, setLoading } = useLoading();

  const fetchApplications = async () => {
    setLoading(true);
    try {
      const res = await getApplications();
      setApplicationTypes(res?.data?.newApplicationSettings?.perType || []);
      setSettings(res?.data?.newApplicationSettings || {});
      setApplications(res?.data?.applications || []);
    } catch {
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    fetchApplications();
  }, []);

  return (
    <div className="applications-container">
      <Box sx={{ display: "flex", alignItems: "flex-start" }}>
        <h2 className="bordered-heading-2">Οι Αιτήσεις μου</h2>

        <Box sx={{ display: "flex", flexDirection: "column", marginLeft: "auto", textAlign: "right" }}>
          <a
            className="ds-link small-font-size"
            href={`${url}/documents/ΛΑΕ-ΟΠΕΚΑ Τρίτεκνες-Πολύτεκνες Μητέρες - Οδηγίες Χρήσης για την Υποβολή Αίτησης.pdf`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Βοήθεια / Οδηγίες Χρήσης για Δικαιούχους Γονείς
          </a>

          {/* <a
            className="ds-link small-font-size"
            href={`${url}/documents/ΛΑΕ-ΟΠΕΚΑ Επιτυχόντα Τέκνα Πανελλαδικών - Οδηγίες Χρήσης για την Υποβολή Αίτησης.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginTop: 10 }}
          >
            Βοήθεια / Οδηγίες Χρήσης για ΕΠΙΤΥΧΟΝΤΕΣ ΠΑΝΕΛΛΑΔΙΚΩΝ
          </a> */}
        </Box>
      </Box>
      <Box sx={{ display: "flex", mb: 2, gap: 2 }}>
        <Button
          onClick={() => setNewApplication((prev) => !prev)}
          variant="contained"
          startIcon={<Add />}
          disabled={!settings?.canCreate}
          sx={{ width: 140 }}
        >
          Νέα Αίτηση
        </Button>
        {settings?.message && !settings?.canCreate && !loading && (
          <Alert
            sx={{ padding: 0.5, flexGrow: 1 }}
            severity={settings?.cssClass || "info"}
          >
            {settings?.message ||
              "Δεν έχετε δικαίωμα δημιουργίας νέας αίτησης."}
          </Alert>
        )}
      </Box>
      {!loading ? (
        <>
          {settings?.canCreate && (
            <NewApplicationPanel
              visible={newApplication && settings?.canCreate}
              applicationTypes={applicationTypes}
              settings={settings}
            />
          )}

          <ApplicationsGrid applications={applications} />
        </>
      ) : (
        <Stack>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </Stack>
      )}
    </div>
  );
};

export default Applications;
